import React, { memo } from 'react';

import { useTranslation } from 'providers/GILT.provider';

const SaveTagButton = ({ className, isDisabled, onClick }) => {
  const { t } = useTranslation();
  return (
    <button data-bem="SaveTagButton" className={className} disabled={isDisabled} onClick={onClick}>
      {t('clientTags.saveTagButton')}
    </button>
  );
};

export default memo(SaveTagButton);
